export default __webpack_public_path__ + "static/media/CNo.58-5.78f14927.jpg";